module.exports = __webpack_public_path__ + "static/media/user-minus.7fad484d.svg";